import { render, staticRenderFns } from "./DoubleMajorApplication.vue?vue&type=template&id=0ec3b511"
import script from "./DoubleMajorApplication.vue?vue&type=script&lang=js"
export * from "./DoubleMajorApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports